import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();

  const [isMenuOpen, setMenuOpen] = useState(false);

  // Toggle menu function
  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking on a nav link
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Toggle body scroll when menu is open/closed
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    
    // Cleanup function
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isMenuOpen]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const navLinks = document.querySelector('.nav-links');
      const hamburger = document.querySelector('.hamburger');
      
      if (isMenuOpen && 
          !navLinks.contains(event.target) && 
          !hamburger.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">TECNOLEAD</div>
        
        {/* Mobile Menu Overlay */}
        <div 
          className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`}
          onClick={closeMenu}
        />
        
        {/* Navigation Links */}
        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="home" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" onClick={closeMenu}>
            {t('nav.home')}
          </Link>
          <Link to="about" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" onClick={closeMenu}>
            {t('nav.about')}
          </Link>
          <Link to="products-section" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" onClick={closeMenu}>
            {t('nav.products')}
          </Link>
          <Link to="contact" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" onClick={closeMenu}>
            {t('nav.contact')}
          </Link>
        </div>
        
        <div className="nav-right">
          <div className="language-container">
            <LanguageSwitcher />
          </div>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
